import React, { useState, useEffect } from 'react';
import { Modal, Row, Col, Button } from 'react-bootstrap'
import { InputPicker, SelectPicker, Form, Schema, InputNumber } from 'rsuite';
import Swal from 'sweetalert2';
import dashboardService from '../../../../services/Public/dashboard.service';
import { getStates, getFirmTypes } from '../../../../services/Shared/codeTable.service'
import PhoneNumberMask from '../../../Shared/GenericComponents/PhoneNumberMask';
import RedStar from '../../../Shared/GenericComponents/RedStar';


function EditLockedContactInfoModal(props) {
    const [recordModel, setRecordModel] = useState({
        organizationType: "",
        domicileState: "",
        dateOfFormation: "",
        phoneNumber: ""
    })
    const [states, setStates] = useState([])
    const [firmTypes, setFirmTypes] = useState([]);

    useEffect(() => {
        getStates().then(setStates);
        getFirmTypes().then(setFirmTypes);
        setRecordModel(props.modaldata);
    }, [props.modaldata])

    const { StringType, ObjectType } = Schema.Types;
    const model = Schema.Model({
        domicileState: ObjectType().when(schema => {
            return !props.modaldata.domicileState ? ObjectType().isRequired("This field is required.") : ObjectType();
        }),
        organizationType: ObjectType().when(schema => {
            return !props.modaldata.organizationType ? ObjectType().isRequired("This field is required.") : ObjectType();
        }),
        dateOfFormation: StringType().when(schema => {
            return !props.modaldata.dateOfFormation ? StringType().isRequired("This field is required.") : StringType();
        }),
        phoneNumber: StringType().when(schema => {
            return !props.modaldata?.phone?.phoneNumber ? StringType().isRequired('This field is required.').pattern(/^([(]\d{3}[)][ ]\d{3}[-]\d{4})|[0-9]{10}/, "Please enter a valid Phone Number") : StringType();
        }),
    })
    const formSubmit = (validation, event) => {
        if (validation)//and other validation
        {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to update this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Save it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    var dataToTransmit = {
                        ...recordModel,
                        phone: { ...recordModel.phone, phoneNumber: recordModel.phoneNumber == '' ? null : recordModel.phoneNumber }
                    };//do mapping if needed
                    dashboardService.postFirmLockedContactInformation(dataToTransmit).then((response) => {
                        if (response.data) {
                            props.onHide();

                        }
                    })
                }
            })
        }
    }


    return (
        <Modal
            {...props}
            animation={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <b className='text-danger'>Required Contact Information</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="recordForm" fluid model={model} formValue={recordModel} onChange={recordModel => setRecordModel(recordModel)} onSubmit={formSubmit} >
                    {!props.modaldata.organizationType &&
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Type of Firm&nbsp;<RedStar />
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control
                                        block
                                        name="organizationType"
                                        accepter={InputPicker}
                                        data={firmTypes} />
                                </Col>
                            </Row>
                        </Form.Group>
                    }
                    {!props.modaldata.domicileState &&
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Domicile Firm State&nbsp;<RedStar />
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control
                                        block
                                        name="domicileState"
                                        searchBy={(userInput, label, dataItem) => { if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput) return true; }}
                                        accepter={InputPicker}
                                        data={states} />
                                </Col>
                            </Row>
                        </Form.Group>
                    }
                    {!props.modaldata.dateOfFormation &&
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Date Formed/Incorporated&nbsp;<RedStar />
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control name="dateOfFormation" type="date" />
                                </Col>
                            </Row>
                        </Form.Group>
                    }
                    {!props.modaldata?.phone?.phoneNumber &&
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Phone Number&nbsp;<RedStar />
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control
                                        accepter={PhoneNumberMask}
                                        name="phoneNumber"
                                        format="(###) ###-####x#####"
                                        mask="_" />
                                </Col>
                            </Row>
                        </Form.Group>
                    }
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button type="submit" form="recordForm" variant="success">Save</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditLockedContactInfoModal;